import { gql, QueryHookOptions, useQuery } from '@apollo/client';

export const PROMO_CODE_QUERY = gql`
  query PromoCode($promoCodeId: String!) {
    promoCode(promoCodeId: $promoCodeId) {
      id
      code
      percentOff
      active
      valid
    }
  }
`;

export interface PromoCodeInfo {
  id: string;
  code: string;
  percentOff: number;
  active: boolean;
  valid: boolean;
}

export interface PromoCodeResult {
  promoCode: PromoCodeInfo;
}

export interface PromoCodeQueryVariables {
  promoCodeId: string;
}

export function usePromoCodeQuery(options?: QueryHookOptions<PromoCodeResult, PromoCodeQueryVariables>) {
  return useQuery<PromoCodeResult, PromoCodeQueryVariables>(PROMO_CODE_QUERY, options);
}
